import AuthApi from "@/services/auth-api";

class FirebaseAuthBackend {
    constructor() {
        
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email, password, name, supplierCode ) => {
        return new Promise((resolve, reject) => {

            AuthApi.register(email, password, name, supplierCode)
            .then(response => {
                document.cookie = 'token' + "=" + response.token + ";" + "10000" + ";path=/";
                document.cookie = 'rtoken' + "=" + response.refreshToken + ";" + "10000" + ";path=/";
                document.cookie = 'authUser' + "=" + response.username + ";" + "10000" + ";path=/";
                document.cookie = 'userFullName' + "=" + response.fullName + ";" + "10000" + ";path=/";


                resolve(response.username);
            }, (error) => {
                reject(this._handleError(error));
            });

        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            AuthApi.signIn(email, password)
            .then(response => {
                //adding cookies
                document.cookie = 'token' + "=" + response.token + ";" + "10000" + ";path=/";
                document.cookie = 'rtoken' + "=" + response.refreshToken + ";" + "10000" + ";path=/";
                document.cookie = 'authUser' + "=" + response.username + ";" + "10000" + ";path=/";
                document.cookie = 'userFullName' + "=" + response.fullName + ";" + "10000" + ";path=/";
                document.cookie = 'userr' + "=" + response.role + ";" + "10000" + ";path=/";


                resolve(response.username);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * forget Password user with given details
     */
    /*forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }*/

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            AuthApi.logout()
            .then(() => {

                //delete cookies
                document.cookie = 'token' + '=; Max-Age=0'
                document.cookie = 'rtoken' + '=; Max-Age=0'
                document.cookie = 'userr' + '=; Max-Age=0'
                document.cookie = 'userFullName' + '=; Max-Age=0'
                document.cookie = 'authUser' + '=; Max-Age=0'

                resolve(true);
            }, (error) => {
                reject(this._handleError(error));
            });
        });

        /*return new Promise((resolve, reject) => {
            AuthApi.
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })

        });*/
    }

    setLoggeedInUser = (user) => {
        document.cookie = 'authUser' + "=" + user + ";" + "10000" + ";path=/";
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        const authUser = ('; '+document.cookie).split(`; authUser=`).pop().split(';')[0];

        if (!authUser)
            return null;
        return authUser;
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        //TODO to be fixed later
        // var errorMessage = error.message;
        // return errorMessage;
        console.log(error)
        return  ("Login ou mot de passe erroné")
    }
}


let _fireBaseBackend = null;

const initFirebaseBackend = () => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend();
    }
    return _fireBaseBackend;
}

const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

const refreshToken = (store) => {
    if (store.state.auth.isRefreshing) {
        return store.state.auth.refreshingCall;
    }

    //refresh token from cookie
    const refreshTokenFromCookie = ('; '+document.cookie).split(`; rtoken=`).pop().split(';')[0];
    // store.commit('auth/setRefreshingState', true);
    const refreshingCall = AuthApi.refresh(refreshTokenFromCookie).then((response) => {
        
        //adding cookies
        document.cookie = 'token' + "=" + response.token + ";" + "10000" + ";path=/";
        document.cookie = 'rtoken' + "=" + response.refreshToken + ";" + "10000" + ";path=/";

        // store.commit('auth/setToken', response.token)
        // store.commit('auth/setRefreshingState', false);
        // store.commit('auth/setRefreshingCall', undefined);
        return Promise.resolve(true);
    // }, (error) => {
    //     return Promise.reject(false);
        }, () => {
        return Promise.reject(false);
                
            }
    
    
    
    );
    // store.commit('auth/setRefreshingCall', refreshingCall);
    return refreshingCall;
}


export { initFirebaseBackend, getFirebaseBackend, refreshToken };
